import React from 'react'
import Manager from '../../public/components/Manager'
import ForgetSwipeCardApplyDetail from './ForgetSwipeCardApplyDetail'
import { reconfigButton, nullDate, TDate, getListFromValues } from '../../../src/public/utility'
import ForgetSwipeCardApplyBatchDiv from '../../business/ForgetSwipeCardApplyBatchDiv'
Ext.require('Ext.Toast')

const disableBatch = ({ state: { selected = null } }) => !selected || !selected.length

const config = () => {
    const handelBatchAction = ({ showDetail, refreshPage, state: { selected }, props: { dispatch } }, title, action) => {
        const list = selected && selected.map(o => o.data.id) || []
        Tyan.pubForm.showDialog(title, props => <ForgetSwipeCardApplyBatchDiv {...props} ids={list} action={action} onSave={refreshPage} />)
    }
    const tiptools = [{
        _tool: '', icon: 'info-circle', ui: 'action', tooltip: o => (
            `
            员工编号:${o['员工编号']}<br>
            员工姓名:${o['员工姓名']}<br>
            部门名称:${o['部门名称']}<br>
            职务名称:${o['职务名称']}<br>
            忘刷卡日期:${o['忘刷卡日期'] && o['忘刷卡日期'] != nullDate && new TDate(o['忘刷卡日期']).toString('yyyy/MM/dd') || ''}<br>
            上班刷卡时间:${o['上班刷卡时间'] && o['上班刷卡时间'] != nullDate && new TDate(o['上班刷卡时间']).toString('yyyy/MM/dd HH:mm') || ''}<br>
            下班刷卡时间:${o['下班刷卡时间'] && o['下班刷卡时间'] != nullDate && new TDate(o['下班刷卡时间']).toString('yyyy/MM/dd HH:mm') || ''}<br>
            上班忘刷卡时间:${o['上班忘刷卡时间'] && o['上班忘刷卡时间'] != nullDate && new TDate(o['上班忘刷卡时间']).toString('yyyy/MM/dd HH:mm') || ''}<br>
            下班忘刷卡时间:${o['下班忘刷卡时间'] && o['下班忘刷卡时间'] != nullDate && new TDate(o['下班忘刷卡时间']).toString('yyyy/MM/dd HH:mm') || ''}<br>
            原因说明:${o['原因说明']}<br>
            备注:${o['备注']}
            `
        )
    }]
    return {
        multiSelect: true,
        buttons: [
            {
                text: '确定', handler: that => handelBatchAction(that, '提交', '提交'), disabled: disableBatch
            },
            {
                text: '驳回申请', handler: that => handelBatchAction(that, '驳回申请', '退回申请'), disabled: disableBatch
            },
        ],
        columns: [
            { _text: '申请编号', field: 'Number', minWidth: 250, search: true, tools: tiptools, flex: 1 },
            { _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1, },
            { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
            { _date: '忘刷卡日期', field: 'SupplementDate', minWidth: 150, filter: true, align: 'left', flex: 1 },
            { _text: '状态名称', field: 'StatusName', minWidth: 150, filter: true, flex: 1, },
            { _: '员工编号', field: 'Person.PersonNo' },
            { _: '员工姓名', field: 'Person.ActualName' },
            { _: '部门名称', field: 'Person.Dep.ShortName' },
            { _: '职务名称', field: 'Person.PersonDuty' },
            { _: '上班刷卡时间', field: 'CheckInTime' },
            { _: '下班刷卡时间', field: 'CheckOutTime' },
            { _: '上班忘刷卡时间', field: 'StartTime' },
            { _: '下班忘刷卡时间', field: 'EndTime' },
            { _: '原因说明', field: 'Explain' },
            { _: '备注', field: 'Remark' },
            { _: 'taskName', field: 'Task.TaskName' }
        ],
        onDoubleTap: ({ showDetail, refreshPage }, data) => {
            showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.id} taskName={data.taskName} />)
        }
    }
}

export default props => <Manager {...props} config={config} />